import imageExists from "image-exists";

export const checkIfImageExists = path => new Promise(resolve => {
  imageExists(path, exists => resolve(exists));
});



// WEBPACK FOOTER //
// ./src/utils/checkIfImageExists.js